<div class="product-table">
    <div class="table-header">
        <h3>{{ 'CONFIGURATION.PANEL.TITLE.LIST_OF_PRODUCTS' | translate }}</h3>
        <div class="header-description">
            {{ 'SUMMARY.HINT.COMPLETE_CONFIGURATION' | translate }}
        </div>
    </div>
    <div class="table-table">
        <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.SELECT' | translate }}
                    <vi-quest-hint
                        [model]="{
                            text: 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.TOOLTIP.SELECT' | translate,
                            important: false
                        }"
                    >
                    </vi-quest-hint>
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <div
                        *ngIf="obj.formGroup"
                        [matTooltip]="'SUMMARY.PRODUCT_TABLE.TOOLTIP.SELECT' | translate"
                        [matTooltipDisabled]="obj.formGroup.controls.selected?.disabled"
                    >
                        <mat-checkbox
                            [formControl]="obj.formGroup.controls.selected"
                            (change)="select(obj)"
                        ></mat-checkbox>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="product-group">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <h6>
                        {{ obj.groupNameTranslation | translate }}
                    </h6>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="image">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <div class="table-image" *ngIf="!obj.groupNameTranslation">
                        <img
                            class="product-image"
                            [src]="productService.getProductImage(obj.material) | async"
                            *ngIf="!obj.groupNameTranslation"
                        />
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="partNumber">
                <mat-header-cell data-at-part-number *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.PART_NUMBER' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <div fxLayout="column" fxLayoutAlign="start start">
                        <span class="alternative-for" *ngIf="obj.alternativeFor">{{
                            'SUMMARY.PRODUCT_TABLE.LABEL.ALTERNATIVE_FOR' | translate : { material: obj.alternativeFor }
                        }}</span>
                        <span>{{ obj.material }}</span>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="quantity">
                <mat-header-cell data-at-quantity *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.QUANTITY' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <mat-form-field
                        *ngIf="canChangeQuantity && obj.formGroup?.controls?.quantity; else quantityNormal"
                        class="quantity"
                    >
                        <input
                            matInput
                            type="number"
                            [formControl]="obj.formGroup.controls.quantity"
                            (change)="changeQuantity(obj)"
                        />
                    </mat-form-field>
                    <ng-template #quantityNormal>{{ obj.quantity }}</ng-template>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="description">
                <mat-header-cell data-at-desciption *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.DESCRIPTION' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    {{ chooseTranslation(obj.translation) }}
                    <app-product-details
                        [productDescription]="chooseTranslation(obj.translation)"
                        [material]="obj.material"
                        [productDetails]="obj.productListDetails"
                        *ngIf="obj.productListDetails?.length"
                    ></app-product-details>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="materialGroup">
                <mat-header-cell data-at-desciption *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.MATERIAL_GROUP' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">{{ obj.materialGroup }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="isOptional">
                <mat-header-cell *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.IS_OPTIONAL' | translate }}
                    <vi-quest-hint
                        [model]="{
                            text: 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.TOOLTIP.IS_OPTIONAL' | translate,
                            important: false
                        }"
                    >
                    </vi-quest-hint>
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <div
                        *ngIf="obj.formGroup"
                        [matTooltip]="'SUMMARY.PRODUCT_TABLE.TOOLTIP.IS_OPTIONAL' | translate"
                        [matTooltipDisabled]="obj.canBeOptional"
                    >
                        <mat-checkbox
                            [formControl]="obj.formGroup.controls.optional"
                            (change)="setOptional(obj)"
                        ></mat-checkbox>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef>
                    {{ 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.ACTIONS' | translate }}
                    <vi-quest-hint
                        [model]="{
                            text: 'SUMMARY.PRODUCT_TABLE.COLUMN_HEADER.TOOLTIP.ACTIONS' | translate,
                            important: false
                        }"
                    >
                    </vi-quest-hint>
                </mat-header-cell>
                <mat-cell *matCellDef="let obj">
                    <div
                        *ngIf="obj.material"
                        [matTooltip]="'SUMMARY.PRODUCT_TABLE.TOOLTIP.DELETE' | translate"
                        [matTooltipDisabled]="obj.canBeDeleted"
                    >
                        <button mat-button color="primary" (click)="deleteProduct(obj)" [disabled]="!obj.canBeDeleted">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                    <div
                        *ngIf="obj.groupNameTranslation"
                        [matTooltip]="'SUMMARY.PRODUCT_TABLE.TOOLTIP.DELETE' | translate"
                        [matTooltipDisabled]="canDeleteProductGroup(obj)"
                    >
                        <button
                            mat-button
                            color="primary"
                            (click)="deleteProductGroup(obj)"
                            [disabled]="!canDeleteProductGroup(obj)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
            <mat-row
                data-at-product
                *matRowDef="let obj; columns: columnsToDisplay"
                [class.alternative-inactive]="isOrHasAlternative(obj) && !obj.selected"
                [class.optional-position]="obj.formGroup?.controls?.optional?.value"
            ></mat-row>
        </mat-table>
    </div>
    <div class="table-button" *ngIf="canEdit">
        <button mat-stroked-button color="primary" [disabled]="!hasEdits" (click)="clearEdits()">
            {{ 'CONFIGURATION.PANEL.TITLE.RESET_PRODUCT_LIST' | translate }}
        </button>
    </div>
</div>
